// src/components/cards/shared/dialogs/EmailBookingFormDialog.tsx

import React from 'react';
import { Typography, Box } from '@mui/material';
import { Assignment as FormIcon } from '@mui/icons-material';
import DialogBase from '../../../common/modal/DialogBase';
import { ModalCancelButton, ModalSaveButton } from '../../../common/Buttons';
import LoadingSpinner from '../../../common/LoadingSpinner';

interface EmailBookingFormDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  clientName: string;
  clientEmail: string;
  sending: boolean;
}

const EmailBookingFormDialog: React.FC<EmailBookingFormDialogProps> = ({
  open,
  onClose,
  onConfirm,
  clientName,
  clientEmail,
  sending,
}) => {
  return (
    <DialogBase
      draggable
      open={open}
      onClose={onClose}
      title="Send Booking Form"
      headerIcon={<FormIcon />}
      headerColor="primary"
      footer={
        <>
          <ModalCancelButton
            onClick={onClose}
            disabled={sending}
            sx={{
              minWidth: { xs: 'auto', sm: '160px' },
              '& .MuiButton-startIcon': { display: { xs: 'none', sm: 'flex' } },
            }}
          />
          <ModalSaveButton
            onClick={onConfirm}
            disabled={sending}
            text={sending ? 'Sending...' : 'Send'}
            sx={{
              minWidth: { xs: 'auto', sm: '160px' },
              '& .MuiButton-startIcon': { display: { xs: 'none', sm: 'flex' } },
              '&.Mui-disabled': {
                backgroundColor: 'primary.main',
                color: 'white',
                opacity: 0.8,
              },
            }}
          />
        </>
      }
    >
      <Box sx={{ mt: 1, textAlign: 'center', position: 'relative' }}>
        {sending && (
          <Box
            sx={{
              position: 'absolute',
              inset: '-5px -24px -20px -24px',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? 'rgba(0,0,0,0.55)'
                  : 'rgba(255,255,255,0.75)',
              borderRadius: '4px',
            }}
          >
            <LoadingSpinner compact size={80} message="" />
          </Box>
        )}

        <Typography sx={{ fontSize: '1.8rem' }}>
          Send booking form to <strong>{clientName}</strong>
        </Typography>
        {clientEmail && (
          <Box
            sx={{
              overflowX: 'auto',
              touchAction: 'pan-x',
              mt: 0.5,
              px: 1,
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Typography
              sx={{
                fontSize: '1.8rem',
                color: 'text.secondary',
                whiteSpace: 'nowrap',
              }}
            >
              {clientEmail}
            </Typography>
          </Box>
        )}
      </Box>
    </DialogBase>
  );
};

export default EmailBookingFormDialog;
